import http from '../../helpers/http';
import {ValidatorError} from '../../hooks/templateHooks/useServerErrorValidation';

export const GetUserItem = async (IdUser) =>{
    const {data} = await http.get(`/JolteonAccess/User/${IdUser}`).catch(error=>ValidatorError(error));
    return data;
}

export const GetUserByWorkGroup = async (Code) =>{
    const {data} = await http.get(`/JolteonAccess/User/WorkGroup/${Code}`).catch(error=>ValidatorError(error));
    return data;
}

export const GetUserByRole = async (Code) =>{
    const {data} = await http.get(`/JolteonAccess/User/Role/${Code}`).catch(error=>ValidatorError(error));
    return data;
}

//Solicita y envia correo de cambio de Contrase?a
export const RequestPasswordChange = async (User,IC) =>{
    const {data} = await http.get(`/JolteonAccess/User/PasswordChange/${User}/Host/${window.location.href.replace(/\//g,"$")}/IC/${IC}`).catch(error=>ValidatorError(error));
    return data;
}

//Actualiza contrase?a desde el restablecimiento de contrase?a
export const UpdatePasswordFromRecover = async (AjaxObj) => {
    const { data } = await http.put(`/JolteonAccess/User/PasswordChange`, AjaxObj).catch(error=>ValidatorError(error));
    return data;
}

//Obtiene una lista de WorkGroups que tiene un Usuario
export const GetWorkGroupByUser = async (IdUser) =>{
    const {data} = await http.get(`/JolteonAccess/User/WorkGroup/${IdUser}`).catch(error=>ValidatorError(error));
    return data;
}

//Obtiene una lista de Roles que tiene un Usuario
export const GetRoleByUser = async (IdUser) =>{
    const {data} = await http.get(`/JolteonAccess/User/Role/${IdUser}`).catch(error=>ValidatorError(error));
    return data;
}

//obtiene lista de compa?ias por usuario
export const GetCompanyByUser = async (IdUser) =>{
    const {data} = await http.get(`/JolteonAccess/User/Company/${IdUser}`).catch(error=>ValidatorError(error));
    return data;
}

export const GetApplicationByUser = async (IdUser) =>{
    const {data} = await http.get(`/JolteonAccess/User/Application/${IdUser}`);
    return data;
}